/*
	Сохраняем параметры сортировки кампаний в localStorage
*/

export const setSortParameters = (sortMethod: string, sortBy: string) => {
	localStorage.setItem("campaignsSortMethod", sortMethod);
	localStorage.setItem("campaignsSortBy", sortBy);
};

export const getSortParameters = () => {
	return {
		sortMethod: localStorage.getItem("campaignsSortMethod"),
		sortBy: localStorage.getItem("campaignsSortBy"),
	};
};
